<template>
  <div id="app-header">
    <v-card class="head_card">
      <v-layout row class="primary head_menu">
        <v-flex shrink class="white_bkg print">
          <img class="logo" alt="Seair" src="../assets/logo_white.png" @click="goHome()" />
        </v-flex>
        <v-flex grow>
          <v-layout column>
            <v-flex class="print">
              <v-layout row>
                <v-spacer xs0></v-spacer>
                <v-flex shrink>
                  <v-toolbar flat class="primary">
                    <v-btn
                      v-show="mobileDevice === false"
                      flat
                      color="white"
                      href="tel:1.800.447.3247"
                      class="print btn"
                    >
                      1.800.447.3247
                    </v-btn>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="no_print" icon flat color="white" @click.stop="loginDialog = !loginDialog" :tabIndex="-1">
                          <v-icon :class="{ 'accent--text': user.id !== null }">person</v-icon>
                        </v-btn>
                      </template>
                      <span>Customer Profile</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="no_print" icon flat color="white" @click.stop="contactDialog = !contactDialog" :tabIndex="-1">
                          <v-icon>phone</v-icon>
                        </v-btn>
                      </template>
                      <span>Contact Us</span>
                    </v-tooltip>
                  </v-toolbar>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-divider class="accent no_print"></v-divider>
            <v-flex xs12 class="no_print">
              <v-layout align-center justify-end v-if="mobileDevice === true">
                <v-spacer></v-spacer>
                <v-flex xs4 sm2>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        icon
                        flat
                        color="white"
                        @click.stop="menuDialog = !menuDialog"
                        class="pa-4"
												:tabIndex="-1"
                      >
                        <v-icon :class="{ 'accent--text': menuDialog !== false }">menu</v-icon>
                      </v-btn>
                    </template>
                    <span>Menu</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <v-layout align-center justify-start v-else>
                <v-flex shrink>
                  <v-toolbar flat class="main_menu">
                    <v-btn
                      v-for="(item, i) in menuItems"
                      :key="i"
                      @click="goToUrl(item.link)"
                      flat
                      class="px-2"
											:tabIndex="-1"
                    >
                      {{ item.title }}
                    </v-btn>
                  </v-toolbar>
                </v-flex>
                <v-spacer></v-spacer>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-spacer></v-spacer>
        </v-flex>
      </v-layout>
    </v-card>

     <v-navigation-drawer absolute temporary clipped right floating v-model="menuDialog">
      <v-toolbar class="v-transparent" color="primary" flat>
        <v-layout row>
          <v-flex xs6 class="pt-3">
            <span class="title white--text">Menu</span>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex shrink>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon flat color="white" @click.stop="menuDialog = !menuDialog" :tabIndex="-1">
                  <v-icon :class="{ 'accent--text': menuDialog !== false }">menu</v-icon>
                </v-btn>
              </template>
              <span>Menu</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-toolbar>

      <v-card>
        <v-layout column>
          <v-flex
            v-for="(item, i) in menuItems"
            :key="i"
            xs10
            class="primary"
          >
            <v-btn
              @click="goToUrl(item.link)"
              flat
              class="primary"
            >
              {{ item.title }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-navigation-drawer>

    <v-navigation-drawer absolute temporary clipped right floating v-model="loginDialog">
      <v-toolbar class="v-transparent" color="primary" flat>
        <span class="title white--text">Login</span>
      </v-toolbar>

      <v-list>
        <v-flex xs12 class="pa-3">
          <LoginForm />
        </v-flex>
      </v-list>
    </v-navigation-drawer>

    <v-navigation-drawer absolute temporary clipped right floating v-model="contactDialog">
      <v-toolbar class="v-transparent" color="primary" flat>
        <span class="title white--text">Contact Us</span>
      </v-toolbar>

      <v-list>
        <ContactDialog />
      </v-list>
    </v-navigation-drawer>

    <v-dialog full-width v-model="cargoDialog">
      <v-toolbar class="v-transparent" color="primary" flat>
        <span class="title white--text">Cargo &amp; Pets</span>
      </v-toolbar>

      <v-list>
        <CargoDialog />
      </v-list>
    </v-dialog>
  </div>
</template>

<script>
import Shared from "@/mixins/Shared.js";
import LoginForm from "@/components/forms/Login.vue";
import ContactDialog from "@/components/dialogs/Contact.vue";
import CargoDialog from "@/content/cargo_pets.vue";
import { createHelpers } from "vuex-map-fields";

const { mapFields } = createHelpers({
  getterType: "getField",
  mutationType: "updateField",
});

export default {
  name: "AppMenu",
  computed: {
    ...mapFields([
      "mobileDevice",
      "devMode",
      "darkMode",
      "minMode",
      "loginDialog",
      "menuDialog",
      "contactDialog",
      "helpDialog",
      "cargoDialog"
    ])
  },
  mixins: [Shared],
  components: {
    LoginForm,
    ContactDialog,
    CargoDialog
  },
  data: () => ({
    menuItems: [
      { title: "Home", link: process.env.VUE_APP_HOME_URL },
      { title: "Scheduled Flights", link: process.env.VUE_APP_HOME_URL + "/schedules-fares/routes-schedules/" },
      { title: "Scenic Tours", link: process.env.VUE_APP_HOME_URL + "/seaplane-tours/" },
      { title: "Charters", link: process.env.VUE_APP_HOME_URL + "/seaplane-charters/" },
      { title: "Fare Details", link: process.env.VUE_APP_HOME_URL + "/schedules-fares/" },
      { title: "Flight Information", link: process.env.VUE_APP_HOME_URL + "/flight-information/" },
      { title: "About Us", link: process.env.VUE_APP_HOME_URL + "/about-seair/overview/" }
    ]
  })
};
</script>

<style lang="scss">
@import "@/styles/_colours.scss";

div.v-toolbar {
  padding: 0px;
  padding-right: 1em;
}
.v-icon.padded {
  padding: 1em;
}
.section {
  padding-bottom: 5px;
  margin-bottom: 5px;
  border-bottom: 1px solid #999;
}
.white {
  background-color: #fff;
}
.title {
  font-weight: bold;
  font-size: 1.2em;
  color: $primary;
}
</style>
